import { getReferenceDataByValue } from '../../functions/get-reference-data-by-id';
import { IReferenceData } from '../../interfaces/form/reference-data.model';

export interface IAttendeeData {
  studentSk?: string;
  isPrimary?: boolean;
  adultId?: number;
  residesWithStudent?: string;
  ngGuardianID?: number;
  relationship?: IReferenceData;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  authorizationCode?: IReferenceData;
  cellPhone?: string;
  workPhone?: string;
  homePhone?: string;
  email?: string;
  spokenLanguage?: IReferenceData;
  writtenLanguage?: IReferenceData;
  streetNumber?: string;
  streetName?: string;
  apartmentNo?: string;
  borough?: IReferenceData;
  city?: string;
  district?: IReferenceData;
  state?: IReferenceData;
  zip?: string;
}

export interface IEditContactData {
  attendee?: IAttendeeData;
}

export interface IEditContactReferenceData {
  language?: IReferenceData[];
}

export class EditContactSubmitModel {
  adultID: number;
  firstName: string;
  lastName: string;
  middleName?: string;
  workPhoneNumber?: string;
  cellPhoneNumber?: string;
  homePhoneNumber?: string;
  email?: string;
  residesWithStudent?: string;
  relationshipCode?: string;
  authorizationCode?: string;
  spokenLanguageCode?: string;
  writtenLanguageCode?: string;
  borough?: string;
  streetNumber?: string;
  streetName?: string;
  apartmentNumber?: string;
  city?: string;
  state?: string;
  zip?: string;
  district?: string;
  ngGuardianID?: number;
  studentSk?: string;
  isPrimary?: boolean;
  writtenLanguageSk?: number;
  spokenLanguageSk?: number;

  constructor(data: IEditContactData, referenceData: IEditContactReferenceData) {
    this.studentSk = data.attendee.studentSk;
    this.isPrimary = data.attendee?.isPrimary;
    this.adultID = data.attendee?.adultId;
    this.residesWithStudent = data.attendee?.residesWithStudent;
    this.ngGuardianID = data.attendee?.ngGuardianID;

    // Basic Information
    this.relationshipCode = data.attendee?.relationship?.value;
    this.firstName = data.attendee?.firstName;
    this.lastName = data.attendee?.lastName;
    this.middleName = data?.attendee?.middleName ?? '';
    this.authorizationCode = data.attendee?.authorizationCode?.value ?? '';

    // Communication
    this.cellPhoneNumber = data.attendee?.cellPhone ?? '';
    this.workPhoneNumber = data.attendee?.workPhone ?? '';
    this.homePhoneNumber = data.attendee?.homePhone ?? '';
    this.email = data.attendee?.email ?? '';

    // Language
    this.spokenLanguageCode = data.attendee?.spokenLanguage?.value ?? '';
    this.writtenLanguageCode = data.attendee?.writtenLanguage?.value ?? '';
    this.spokenLanguageSk = Number(
      getReferenceDataByValue(
        data.attendee?.spokenLanguage?.value,
        referenceData.language
      )?.id
    );
    this.writtenLanguageSk = Number(
      getReferenceDataByValue(
        data.attendee?.writtenLanguage?.value,
        referenceData.language
      )?.id
    );

    // Housing
    this.streetNumber = data.attendee?.streetNumber;
    this.streetName = data.attendee?.streetName;
    this.apartmentNumber = data.attendee?.apartmentNo;
    this.borough = data.attendee?.borough?.value;
    this.city = data.attendee?.city;
    this.district = data.attendee?.district?.value;
    this.state = data.attendee?.state?.value;
    this.zip = data.attendee?.zip;
  }
}
